import React, { useState } from 'react';
import { BwjNavigationWarningUi } from './ui';
import { INavigationObjectionProps, NavigationServiceEvents } from '../../services/navigation';
import { useEventNotification } from '../../services/event-notification';

const subscriberId = 'Component.BwjNavigationWarning';

export const BwjNavigationWarning: React.FunctionComponent = () => {
  const [displayProps, setDisplayProps] = useState<INavigationObjectionProps | null>(null);

  useEventNotification((props: INavigationObjectionProps) => setDisplayProps(props), [],
    NavigationServiceEvents.NavigationDecisionRequested, subscriberId);

  const onProceedRequested = () => {
    setDisplayProps(null);
    !!displayProps && displayProps.proceedNavigation();
  };

  const onCancelRequested = () => {
    setDisplayProps(null);
    !!displayProps && displayProps.cancelNavigation();
  };

  return (
    <BwjNavigationWarningUi
      show={!!displayProps}
      title={displayProps?.title ?? ''}
      warning={displayProps?.warning ?? ''}
      proceedPrompt={displayProps?.proceedPrompt ?? ''}
      cancelPrompt={displayProps?.cancelPrompt ?? ''}
      onProceedRequested={onProceedRequested}
      onCancelRequested={onCancelRequested}
    />
  );
};
